import {Directive, HostListener, Injector} from "@angular/core";
import {MatTooltip} from "@angular/material/tooltip";
import {SimUserExtendedService} from "@services";
import {EventEmitterService} from "@event-emitter";

@Directive({
	selector: "[appTooltip]",
	providers: [MatTooltip],
	standalone: true,
})
export class PermissionTooltipDirective {
	public showTooltip: boolean = false;
	public message: string = "";
	public tooltip: MatTooltip;
	public _userService: SimUserExtendedService;
	public _emitterService: EventEmitterService;

	constructor(private readonly injector: Injector) {
		this.tooltip = injector.get(MatTooltip);
		this._userService = injector.get(SimUserExtendedService);
		this._emitterService = injector.get(EventEmitterService);
	}

	@HostListener("mouseover") mouseover(): void {
		if (this._userService.user.isHost && this.showTooltip) {
			this.buildMessage();
			this.tooltip.show();
			this.tooltip.tooltipClass = "permissionsTooltip";
		}
	}

	@HostListener("mouseleave") mouseleave(): void {
		this.tooltip.hide();
	}

	private buildMessage(): void {
		if (!!this.tooltip.message.length) {
			if (!this.tooltip.message.includes(this.message)) {
				this.tooltip.message += `, ${this.message}`;
			}
		} else {
			this.tooltip.message = this.message;
		}
	}

	public setupTooltip(): void {
		this._emitterService.onToggleShowPermissionTooltips.subscribe((value: {visible: boolean}) => {
			this.showTooltip = value.visible;
		});
	}
}
